<section class="video" id="video" [style.background-image]="'url(' + imagePath + ')'">
  <div class="texts">
    <span class="title">{{ "video desc" | translate }}</span>
    <span class="subTitle">{{ "Youtube popover" | translate }}</span>
  </div>

  <div class="icon" [class.active]="active" (click)="popupAction(true)">
    <img src="../../../../assets/img/play-btn.png" alt="tourdeatmenia-video">
  </div>

  @if (active) {
    <div class="video-PopUpWrapper" (click)="popupAction(false)">
      <div class="video-popUp">
        <div class="overley">
          <div class="iconPop"><i (click)="popupAction(false)" class="fas fa-times"></i></div>
          <div class="iframe">
            <iframe
              id="video1"
              [src]="safeURL"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>
  }
</section>

